import { yup, validationMessages } from '@medely/ui-kit';
import { OTHER_REFERRAL_ID } from './constants';

export const accountInfoStepSchema = yup.object({
  first_name: yup.string().required('Required'),
  last_name: yup.string().required('Required'),
  nickname: yup.string().nullable(),
  address_zip: yup
    .mixed<number | string>()
    .required(validationMessages.zip.required)
    .test('zip5', validationMessages.zip.length, (value) => {
      const raw = String(value ?? '');
      return /^\d{5}$/.test(raw);
    }),
  phone_number: yup.string().phone().required('Required'),
  referral_source_id: yup.number().nullable(),
  other_referral_source: yup.string().when('referral_source_id', (referral_source_id, schema) => {
    return (referral_source_id as unknown as number | null | undefined) === OTHER_REFERRAL_ID
      ? schema.required('Required')
      : schema.notRequired();
  }),
});
